/* eslint-disable @typescript-eslint/naming-convention */
export enum FORM_COMPONENT_BASIC_INPUT_TYPE {
  text = 'text',
  info = 'info',
  number = 'number',
  date = 'date',
  time = 'time',
  email = 'email',
  address = 'address',
  phone = 'phone',
  yesNo = 'yesNo',
  checkbox = 'checkbox',
  radio = 'radio',
  image = 'image',
  file = 'file',
  link = 'link',
  button = 'button',
  singleCheckbox = 'singleCheckbox',
  gender = 'gender',
  documentReview = 'documentReview',
  bankAccountNumber = 'bankAccountNumber',
  routingNumber = 'routingNumber',
  branchTransitNumber = 'branchTransitNumber',
  financialInstitutionNumber = 'financialInstitutionNumber',
  checkboxDisable = 'checkboxDisable',
  correspondenceLanguage = 'correspondenceLanguage',
  sin = 'sin',
  ssn = 'ssn',
  signature = 'signature',
}
export enum FORM_COMPONENT_FORM_BUILDER_INPUT_TYPE {
  section = 'section',
}

export enum FORM_COMPONENT_ADVANCED_INPUT_TYPE {
  sinAdvanced = 'sinAdvanced',
  ssnAdvanced = 'ssnAdvanced',
  documentPreview = 'documentPreview',
  americanBank = 'americanBank',
  canadianBank = 'canadianBank',
  earliestStartDate = 'earliestStartDate',
  addressValidator = 'addressValidator',
  signatureAdvanced = 'signatureAdvanced',
  emergencyContact = 'emergencyContact',
  miscellaneous = 'miscellaneous',
  fullName = 'fullName',
}
